import { TopPharmacyBadge } from "@au-schein-de/au-ui-library";
import { cva, type VariantProps } from "class-variance-authority";

const productDetailsSectionTitleVariant = cva(
	"max-w-[55%] md:max-w-[70%] text-body-sm-emphasis text-start text-wrap whitespace-normal",
	{
		variants: {
			variant: {
				selected: "text-ansay-main",
				normal: "text-gray-700",
			},
		},
		defaultVariants: {
			variant: "normal",
		},
	},
);

export function ProductDetailsVendorItemName({
	title,
	variant,
	featured,
}: {
	title: string;
	featured?: boolean;
} & VariantProps<typeof productDetailsSectionTitleVariant>) {
	return (
		<div
			className={productDetailsSectionTitleVariant({ variant })}
			title={title}
		>
			<div className="flex items-start gap-1">
				{featured && (
					<span className="flex h-[1lh] items-center text-body-bold">
						<TopPharmacyBadge />
					</span>
				)}
				<p className="text-body-bold text-start text-wrap whitespace-normal">
					{title}
				</p>
			</div>
		</div>
	);
}
